const More = () => {
  return (
    <svg width="28" height="6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm11 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm14-3a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        fill="#fff"
      />
    </svg>
  );
};
export default More;
